import React from "react";
import { Container, Row, Col } from "reactstrap";
import IncentiveReports from "./IncentiveReports.jsx";
import RestartChurnedOrg from "./RestartChurnedOrg.jsx";

// Admin-only tools for CS admins. Add each new admin action as its own card below.
const AdminActions = ({ user_details }) => {
	if (!user_details) return null;
	const is_cs_admin = !!(user_details.role && user_details.role.store && user_details.role.store.includes('customer_success_admin'));

	return (
		<Container className="mt-3" fluid>
			<Row>
				<Col>
					<h2 className="mb-3">Admin Actions</h2>
					{is_cs_admin
						? <><IncentiveReports /><RestartChurnedOrg /></>
						: <div>Only CS admins can use this page.</div>}
				</Col>
			</Row>
		</Container>
	);
};

export default AdminActions;
